import { FUND } from "../actions/types"

const initializeState = { cards: [], history: [] };

const fundReducer = (state = initializeState, action) => {
    switch (action.type) {
        
        case FUND.FUND_USSD_SUCCESS:
            return {...state, ussd: action.payload };
        
        case FUND.FUND_USSD_FAIL:
            return { ...state, ussd: false };
        
        case FUND.FETCH_CARD_SUCCESS:
            return { ...state, cards: action.payload }
        
        case FUND.WALLET_HISTORY_SUCCESS:
            return {...state, history: action.payload}
        
        default:
            return state
    }
}

export default fundReducer;